import React from 'react';

export const BehavioralStep = ({ formData, setFormData }) => (
  <div className="space-y-6 max-w-md mx-auto">
    <div>
      <p className="text-sm font-medium text-[#1A3A4A] dark:text-[#F0EDE8] mb-3">What's your biggest challenge with eating well?</p>
      <div className="grid grid-cols-2 gap-2">
        {[
          { id: 'time_convenience', label: 'Time / convenience' },
          { id: 'cravings', label: 'Cravings' },
          { id: 'not_knowing', label: "Not knowing what to eat" },
          { id: 'emotional_eating', label: 'Emotional eating' },
          { id: 'social_pressure', label: 'Social pressure' },
        ].map(o => (
          <button
            key={o.id}
            data-testid={`challenge-${o.id}`}
            onClick={() => setFormData(p => ({ ...p, biggest_challenge: o.id }))}
            className={`px-3 py-2.5 rounded-xl text-sm font-medium text-left transition border-2 ${
              formData.biggest_challenge === o.id
                ? 'border-[#6B9E8A] bg-[#6B9E8A]/10 text-[#1A3A4A] dark:text-[#F0EDE8]'
                : 'border-transparent bg-white/80 dark:bg-[#141C22]/80 text-[#7A7A72] hover:border-[#1A3A4A]/10'
            }`}
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
    <div>
      <p className="text-sm font-medium text-[#1A3A4A] dark:text-[#F0EDE8] mb-3">What motivates you most?</p>
      <div className="grid grid-cols-2 gap-2">
        {[
          { id: 'data_progress', label: 'Data & progress' },
          { id: 'encouragement', label: 'Encouragement & positivity' },
          { id: 'practical_tips', label: 'Practical tips & recipes' },
          { id: 'accountability', label: 'Accountability' },
        ].map(o => (
          <button
            key={o.id}
            data-testid={`motivation-${o.id}`}
            onClick={() => setFormData(p => ({ ...p, motivation_style: o.id }))}
            className={`px-3 py-2.5 rounded-xl text-sm font-medium text-left transition border-2 ${
              formData.motivation_style === o.id
                ? 'border-[#4A90D9] bg-[#4A90D9]/10 text-[#1A3A4A] dark:text-[#F0EDE8]'
                : 'border-transparent bg-white/80 dark:bg-[#141C22]/80 text-[#7A7A72] hover:border-[#1A3A4A]/10'
            }`}
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
    <div>
      <p className="text-sm font-medium text-[#1A3A4A] dark:text-[#F0EDE8] mb-3">How would you describe your relationship with food?</p>
      <div className="space-y-2">
        {[
          { id: 'love_food', label: 'I love food and want to eat smarter' },
          { id: 'more_awareness', label: 'I want more awareness of what I eat' },
          { id: 'healthier_relationship', label: "I'm working on a healthier relationship with food" },
        ].map(o => (
          <button
            key={o.id}
            data-testid={`food-rel-${o.id}`}
            onClick={() => setFormData(p => ({ ...p, food_relationship: o.id }))}
            className={`w-full px-4 py-3 rounded-xl text-sm font-medium text-left transition border-2 ${
              formData.food_relationship === o.id
                ? 'border-[#E5A84B] bg-[#E5A84B]/10 text-[#1A3A4A] dark:text-[#F0EDE8]'
                : 'border-transparent bg-white/80 dark:bg-[#141C22]/80 text-[#7A7A72] hover:border-[#1A3A4A]/10'
            }`}
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
    <div>
      <p className="text-sm font-medium text-[#1A3A4A] dark:text-[#F0EDE8] mb-3">How experienced are you with nutrition and food tracking?</p>
      <div className="space-y-2">
        {[
          { id: 'pro', label: "I'm a pro", desc: 'I know my macros, just give me the tools' },
          { id: 'intermediate', label: 'Somewhere in the middle', desc: 'I know basics but could use guidance' },
          { id: 'beginner', label: "I'm brand new", desc: "I don't know where to start, help me" },
        ].map(o => (
          <button
            key={o.id}
            data-testid={`expertise-${o.id}`}
            onClick={() => setFormData(p => ({ ...p, expertise_level: o.id }))}
            className={`w-full px-4 py-3 rounded-xl text-left transition border-2 ${
              formData.expertise_level === o.id
                ? 'border-[#8B6FA0] bg-[#8B6FA0]/10 text-[#1A3A4A] dark:text-[#F0EDE8]'
                : 'border-transparent bg-white/80 dark:bg-[#141C22]/80 text-[#7A7A72] hover:border-[#1A3A4A]/10'
            }`}
          >
            <span className="text-sm font-medium block">{o.label}</span>
            <span className="text-xs opacity-60 mt-0.5 block">{o.desc}</span>
          </button>
        ))}
      </div>
    </div>
  </div>
);
